import { createFileRoute } from "@tanstack/react-router";

import { OrganiserDialog } from "../features/organisers/components/OrganiserDialog";
import { organiserQueries } from "../features/organisers/api/queries";
import { venueQueries } from "../features/venues/api/queries";
import { areaQueries } from "../features/weather/api/queries";
import { AppHeader } from "../shared/ui/AppHeader";

export const Route = createFileRoute("/_authenticated/organisers/new")({
  loader: ({ context: { queryClient } }) =>
    // All three in parallel: the dialog reads the row from the list, and the
    // form's default-venue and default-area pickers need theirs before it
    // renders.
    Promise.all([
      queryClient.ensureQueryData(organiserQueries.list()),
      queryClient.ensureQueryData(venueQueries.list()),
      queryClient.ensureQueryData(areaQueries.list()),
    ]),
  component: NewOrganiserPage,
});

/** Chrome behind the modal; the dialog owns the form. */
function NewOrganiserPage() {
  return (
    <>
      <AppHeader />
      <OrganiserDialog organiserId={null} />
    </>
  );
}
